import { Injectable } from '@tanbo/vue-di-plugin'
import { nextTick, Ref } from 'vue'

export const clipboard = function (node: Node) {
  if (!node) {
    return
  }

  const range = document.createRange()
  range.selectNodeContents(node)
  const selection = document.getSelection()
  selection.removeAllRanges()
  selection.addRange(range)
  document.execCommand('copy')
}

@Injectable()
export class DashboardService {
  constructor (private isRouterAlive: Ref<boolean>) {
  }

  async reload () {
    this.isRouterAlive.value = false
    await nextTick()
    this.isRouterAlive.value = true
  }
}
